var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 95,
    viewBox: "0 0 100 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3381 0.00250016H62.9288L32.2105 91.0709C32.0535 91.536 31.8249 91.9737 31.533 92.3684C31.2417 92.7635 30.8905 93.1097 30.4917 93.396C30.0929 93.6823 29.6529 93.9048 29.1853 94.0548C28.7178 94.2048 28.2303 94.2823 27.7402 94.2823H4.71122C3.96367 94.2823 3.22612 94.1048 2.56108 93.7623C1.89533 93.4207 1.32064 92.9253 0.884716 92.3172C0.448508 91.7091 0.163143 91.0059 0.0521613 90.2658C-0.059096 89.5258 0.00840845 88.7695 0.247174 88.0607L28.8666 3.21146C29.0228 2.74643 29.2516 2.3089 29.5441 1.91387C29.8354 1.51885 30.1879 1.17258 30.5854 0.886307C30.9842 0.600039 31.4242 0.377524 31.8918 0.227515C32.3593 0.077505 32.8468 0 33.3369 0V0.00125008L33.3381 0.00250016Z",
    fill: "url(#paint0_linear_755_12578)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8866 94.2825H61.3161C61.0199 94.2825 60.7236 94.2549 60.4311 94.1987C60.1398 94.1437 59.8535 94.0612 59.5773 93.9524C59.301 93.8437 59.036 93.7087 58.7847 93.5512C58.5338 93.3926 58.2982 93.211 58.0809 93.0086L27.929 64.8493C27.6101 64.5515 27.3879 64.1648 27.2914 63.7392C27.195 63.3137 27.2289 62.8689 27.3888 62.4629C27.5487 62.0569 27.827 61.7084 28.1877 61.4628C28.549 61.2178 28.9753 61.0865 29.4116 61.0865H76.3346L87.8841 94.2837L87.8866 94.2825Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.035 0.00250002L42.3212 61.0928L76.1659 61.0853L87.7754 94.2825H61.3049C61.0312 94.28 60.7574 94.255 60.4874 94.2062C60.2174 94.1575 59.9523 94.0862 59.6948 93.9912C59.1784 93.8031 58.6981 93.5278 58.2747 93.1774L37.9209 74.1812L32.223 90.9848C32.0755 91.4048 31.873 91.8036 31.6205 92.1698C31.1144 92.9067 30.4221 93.4963 29.6141 93.8787C29.2118 94.069 28.7859 94.2048 28.3478 94.2825H4.72496C3.96991 94.285 3.22486 94.105 2.55357 93.7575C1.88217 93.4102 1.30424 92.9065 0.868637 92.2887C0.433029 91.671 0.152549 90.9575 0.0509055 90.2085C-0.0503701 89.4591 0.0297999 88.6965 0.284671 87.9846L28.8578 3.27522C29.0066 2.80144 29.2303 2.35516 29.5203 1.95263C29.8091 1.5501 30.1616 1.19508 30.5617 0.90256C30.9617 0.61004 31.4067 0.382525 31.878 0.230015C32.3493 0.077505 32.8431 -1.42492e-07 33.3393 0.00250002H63.0363H63.035Z",
    fill: "url(#paint1_linear_755_12578)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7524 88.0609C99.9913 88.7701 100.059 89.5258 99.9487 90.266C99.8376 91.0059 99.5527 91.7089 99.1174 92.3174C98.6814 92.9252 98.1069 93.4204 97.4415 93.7621C96.7761 94.1039 96.0389 94.2823 95.2909 94.2826H62.3112C63.0587 94.2826 63.7963 94.1038 64.4626 93.7625C65.1276 93.4212 65.7027 92.925 66.1389 92.3174C66.5752 91.7099 66.8602 91.0061 66.9715 90.266C67.0828 89.526 67.0153 88.7697 66.7765 88.0609L38.1558 3.20903C37.8408 2.27432 37.2405 1.46197 36.4395 0.886372C36.0419 0.600103 35.6019 0.378838 35.1356 0.228828C34.6693 0.0788185 34.1818 0.00256348 33.693 0.00256348H66.6715C67.1615 0.00256348 67.6478 0.0788185 68.1153 0.228828C68.5816 0.378838 69.0216 0.601353 69.4204 0.886372C69.8179 1.17264 70.1692 1.51891 70.4605 1.91269C70.7517 2.30647 70.9793 2.74399 71.1368 3.20903L99.7574 88.0609H99.7524Z",
    fill: "url(#paint2_linear_755_12578)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_755_12578",
    x1: 44.1376,
    y1: 6.99045,
    x2: 13.3856,
    y2: 97.8338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_755_12578",
    x1: 53.7257,
    y1: 49.3183,
    x2: 46.6127,
    y2: 51.7309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_755_12578",
    x1: 49.8004,
    y1: 4.34035,
    x2: 83.5526,
    y2: 94.2588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.6b2433a55ae52dad17fe8ee3769a49fa.svg";
export { ForwardRef as ReactComponent };